import { SettingActionTypes } from './setting.model';
require('dotenv').config();

export const initialState = {
    setting: {},
    isLoading: false
};

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case SettingActionTypes.UPDATE_SETTING_REQUEST:
        case SettingActionTypes.FETCH_SETTINGS_REQUEST: {
            return {
                ...state,
                isLoading: true
            };
        }

        case SettingActionTypes.UPDATE_SETTING_SUCCESS:
        case SettingActionTypes.FETCH_SETTINGS_SUCCESS: {
            return {
                ...state,
                setting: action.payload,
                isLoading: false
            };
        }

        case SettingActionTypes.FETCH_SETTINGS_FAILURE:
        case SettingActionTypes.UPDATE_SETTING_FAILURE:
            {
                return {
                    ...state,
                    isLoading: false
                };
            }

        default: {
            return state;
        }
    }
};

export { reducer as SettingReducer };

